import { getData, postData } from '@/utils/http'
import config from '@/config'
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],

		//查询条件
		pageIndex: 1,
		total: 0,
		projectId: '',
		deptId: "",
		status: '',
		code: ''
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading
		},
		CHANGE_ADD_LOADING(state, addLoading) {
			state.addLoading = addLoading
		},
		CHANGE_TABLE_DATA(state, changeData) {
			state.tableList = changeData.data.rows
			state.total = changeData.total
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
				state[changeData['changeKey']] = [changeData['data']]
			} else {
				state[changeData['changeKey']] = changeData['data']
			}
		},
		CHANGE_TABLE_INDEX(state, value) {
			state.pageIndex = value
		}
	},
	actions: {
		//获取列表
		getList({ commit, state }) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/page`, {
					page: state.pageIndex,
					size: config.pageSize,
					projectId: state.projectId,
					status: state.status,
					code: state.code
				}).then(res => {
					if (res.state == 1) {
						commit('CHANGE_TABLE_DATA', res)
						resolve({
							state: 1,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},
		//根据调度获取订单信息
		
		getOrderMsg({ commit, state }, id) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/order/list/${id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},
		

		//添加
		add({ commit }, addData) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/`, addData).then(res => {
					if (res.state == 1) {
						//构建数据体系
						var toRenderView = [];
						for (var i in res.data) {

							for (var j = 0; j < res.data[i].length; j++) {
								toRenderView.push({
									...res.data[i][j],
									dispatchPlanId:i,
									ordeIndex:j
								});
							}
						}
						resolve({
							state: 1,
							data: toRenderView,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						})
					}
				})
			})
		},

		//获取我的项目列表
		getMyProjectList({ commit, state }, deptId) {
			return new Promise(resolve => {
				getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},
		//获取可以调度的订单
		getWatiDispatchOrder({ commit, state }, data) {
			return new Promise((resolve) => {
				getData(`logistics/order/list?code=${data.code}&projectId=${data.projectId}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},
		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},


		//运力池
		//获取可用车辆
		logisticsCarGetIdleList({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/car/get/idle/list`, {
					start: data.start,
					end: data.end,
					code: data.code,
					carNo: data.carNo,
					deptId: data.deptId,
					orderIds:data.orderIds.join(','),
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取可用驾驶员
		logisticsDriverGetIdleList({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/driver/get/idle/list`, {
					start: data.start,
					end: data.end,
					name: data.name,
					deptId: data.deptId,
					orderIds:data.orderIds.join(',')
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取可用车辆
		logisticsCarGetIdleListOut({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/car/get/un/idle/list`, {
					start: data.start,
					end: data.end,
					code: data.code,
					carNo: data.carNo,
					orderIds:data.orderIds.join(','),
					deptId: data.deptId
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取可用驾驶员
		logisticsDriverGetIdleListOut({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/driver/get/un/idle/list`, {
					start: data.start,
					end: data.end,
					name: data.name,
					deptId: data.deptId,
					orderIds:data.orderIds.join(','),
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取内部挂车
		logisticsCarGuaGetIdleList({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/car/get/trailer/list`, {
					start: data.start,
					end: data.end,
					code: data.code,
					carNo: data.carNo,
					orderIds:data.orderIds.join(','),
					deptId: data.deptId
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},
		//获取外部挂车
		logisticsCarGuaGetIdleListOut({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/car/get/un/trailer/list`, {
					start: data.start,
					end: data.end,
					code: data.code,
					carNo: data.carNo,
					orderIds:data.orderIds.join(','),
					deptId: data.deptId
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},


		//确认调度
		sureDispatch({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/submit`, data).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取调度详情
		dispatchGetInfo({ commit, state }) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/get/${state.activeItem.id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},


		//正在调度的订单
		dispatchOrderList({ commit, state }) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/order/list/${state.activeItem.id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						})
					}
				})
			})
		},


		//获取调度计划
		dispatchPlanList({ commit, state }) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/plan/list/${state.activeItem.id}`).then(res => {
					if (res.state == 1) {


						var toRenderView = [];

						//处理数据
						var dataOneArray = [];
						var dataTwo = [];
						for (var i = 0; i < res.data.length; i++) {
							res.data[i]['dataViews'] = [];
							dataOneArray = res.data[i]["dates"].split(",");
							for (var j = 0; j < dataOneArray.length; j++) {
								dataTwo = dataOneArray[j].split("|");
								toRenderView.push({
									id: `${i}${j}`,
									dispatchPlanId: res.data[i]['id'],
									remark: res.data[i]['remark'],
									projectId: res.data[i]['projectId'],
									status: res.data[i]['status'],
									dispatchPlanIndex: i + 1,
									dispatchPlanOrderIndex: j + 1,
									dispatchId: res.data[i]['dispatchId'],
									orderIndex: res.data[i]['orderIndex'],
									un: res.data[i]['un'],
									date1: dataTwo[0],
									date2: dataTwo[1],
									date3: dataTwo[2],
									date4: dataTwo[3],
									date5: dataTwo[4],
								});
							}
						}
						resolve({
							state: 1,
							data: toRenderView,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						})
					}
				})
			})
		},

		//更新调度时间
		dispatchUpdateTime({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/update/time`, {
					startTime: data.startTime,
					endTime: data.endTime,
					id: state.activeItem.id,
					msg:data.msg
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取运送单列表
		dispatchPlanWayBillList({ commit, state }, id) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/plan/waybill/list/${id}`).then(res => {
					if (res.state == 1) {


						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},


		//获取运力池
		dispatchTranList({ commit, state }, id) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/trans/list/${state.activeItem.id}`).then(res => {
					if (res.state == 1) {

						for (var i = 0; i < res.data.length; i++) {
							// res.data[i]['driverList'] = {
							// 	name: res.data[i]['driverName'],
							// 	id: res.data[i]['driverId'],
							// };
							// res.data[i]['carList'] = {
							// 	carNo: res.data[i]['carNo1'],
							// 	id: res.data[i]['carId1'],
							// 	carVO: res.data[i]['carNo2'] ? {
							// 		carNo: res.data[i]['carNo2'],
							// 		id: res.data[i]['carId2'],
							// 	} : ""
							// };
							res.data[i]["isServer"] = true;
						}

						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},

		//修改运力状态
		dispatchTranOperate({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/trans/operate`, data).then(res => {
					if (res.state == 1) {


						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},

		//新增运力池
		dispatchTranAdd({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/trans/add`, data).then(res => {
					if (res.state == 1) {

						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},

		//删除运力池
		dispatchTranRemove({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/trans/remove`, data).then(res => {
					if (res.state == 1) {

						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},


		//撤销调度
		dispatchTranCancel({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/cancel`, data).then(res => {
					if (res.state == 1) {

						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},
		//终止调度
		dispatchPlanOperate({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/plan/operate`, data).then(res => {
					if (res.state == 1) {

						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},

		//调度订单操作
		dispatchOrderOperate({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/order/operate`, data).then(res => {
					if (res.state == 1) {

						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},

		//历史调度
		dispatchHistory({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/history/${data.num}?projectId=${data.projectId}`).then(res => {
					if (res.state == 1) {


						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						})
					}
				})
			})
		},


		//查看订单运单列表
		dispatchOrderWayBillList({ commit, state }, id) {
			return new Promise(resolve => {
				getData(`logistics/dispatch/order/waybill/list/${state.activeItem.id}/${id}`).then(res => {
					if (res.state == 1) {


						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},


		//判断车辆或人员是否可用
		logisticsDispatchHistoryCheck({ commit, state }, data) {
			return new Promise(resolve => {
				postData(`logistics/dispatch/history/check`,data).then(res => {
					if (res.state == 1) {

						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: {},
							msg: res.msg
						})
					}
				})
			})
		},




		//写入当前操作条目
		setActiveItem({ commit }, item) {
			commit('CHANGE_ACTIVE_ITEM', item)
		},

		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit('CHANGE_SEARCH_COLL', changeData)
		},
		//修改分页
		setPageIndex({ commit }, value) {
			commit('CHANGE_TABLE_INDEX', value)
		},
		//修改添加loading
		changeAddLoading({ commit }, value) {
			commit('CHANGE_ADD_LOADING', value)
		},
		//修改添加loading
		changeListLoading({ commit }, value) {
			commit('CHANGE_TABLE_LOADING', value)
		}
	}
}
